var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-complete"},[_c('AppHeader'),_c('div',{staticClass:"flex-grow-1 d-flex flex-column"},[_c('router-view',{staticClass:"page flex-grow-1 app-content-wrapper"})],1),_c('AppFooter'),_c('ConfirmBox'),_c('AlertBox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }